import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth uses an httpOnly cookie set by the backend — no tokens in localStorage.
const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.response.use(
  (r) => r,
  (err) => {
    // /auth/verify 401 is handled by AuthContext (shows the login gate) — hard-redirecting
    // on it causes reload loops for browsers with stale cookies.
    const url = err.config?.url || "";
    if (
      err.response?.status === 401 &&
      !url.includes("/auth/") &&
      window.location.pathname !== "/login"
    ) {
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export default api;
